import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddOrEditGroupPage } from './add-or-edit-group.page';
import { QuestionComponent } from './question/question.component';
import { DateSelectorModule } from '../shared/date-selector.module';

const routes: Routes = [
  {
    path: '',
    component: AddOrEditGroupPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateSelectorModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddOrEditGroupPage, QuestionComponent]
})
export class AddOrEditGroupPageModule { }
